import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 1000px;
  padding: 16px;
`;

export const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const Toolbar = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
`;

export const CardList = styled.div`
  border: 1px solid #d8e0ec;
  border-radius: 8px;
  overflow: hidden;
`;

export const CardRow = styled.div`
  border-bottom: 1px solid #e8edf5;
  display: flex;
  justify-content: space-between;
  padding: 18px 20px;

  &:last-child {
    border-bottom: 0;
  }
`;

export const LeftColumn = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

export const RightColumn = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-left: 16px;
`;

export const InlineRow = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
`;

export const Block = styled.div`
  background: #f5f5f5;
  border-radius: ${props => props.radius || '4px'};
  height: ${props => props.height || '14px'};
  width: ${props => props.width || '100%'};
`;
